// todo:ai-review
import type { BookInfo } from "#layers/books/types"

/**
 * Get list of all books from the API.
 */
export function useBooks() {
	return useAsyncData("books-list", async () => {
		const books = await $fetch<BookInfo[]>("/api/books")
		return books
	})
}
